<template>
   <!-- <table class="table is-fullwidth">
       <thead>
           <tr>
               <th v-if="settings.showRowNo">
                   Nr.
                </th>
                <th v-for="header in columns" v-bind:key="header.id">
                    {{ header.title }}
                </th>
           </tr>
       </thead>
       <tfoot v-if="checkboxes.keys.length > 0">
           <th></th>
           <th v-for="footer in columns" v-bind:key="footer.id">
               <div class="buttons" v-if="footer.type === 'checkbox'">
                    <a class="button is-small is-primary">
                       {{ $t("button.sendToApproval") }}
                    </a>
                   <a class="button is-small is-danger">
                       {{ $t("button.delete") }}
                    </a>
                </div>
           </th>
       </tfoot>
       <tbody>
           <tr v-for="(row, key) in rows" v-bind:key="row.id">
               <td v-if="settings.showRowNo">
                   <b>{{ key + 1 }}</b>
               </td>
               <td v-for="column in columns" v-bind:key="column.id" v-bind:style="column.style">
                   <span v-if="column.type === 'select'">
                       <ProjectSelect 
                        :column="column"
                       />
                   </span>
                    <span v-if="column.type === 'date'">
                        <div class="field">
                            <div class="control">
                                <Datepicker
                                    v-model="date"
                                    :language="da" 
                                    class="input" 
                                    input-class="date-picker"
                                    format="dd/MM/yy"
                                    :monday-first="true"
                                ></Datepicker>
                            </div>
                        </div>
                   </span>
                    <span v-if="column.type === 'checkbox'">
                        <label class="checkbox">
                            <input 
                                type="checkbox" 
                                v-model="checkboxes.keys"
                                :value="row.id" 
                            >
                        </label>
                    </span>
                    <span v-if="column.type === 'number'">
                        <input class="input" type="number">
                   </span>
                </td>
            </tr>
       </tbody>
   </table> -->
    <div>
      <!-- mobile project registration form -->
      <div class="is-hidden-tablet">
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">{{$t("settings.project")}}</label>
          </div>
          <div class="field-body">
            <div class="field is-narrow">
              <div class="control">
                <ProjectSelect 
                  @project="setProject" 
                  @projectTask="setProjectLine"
                  :all-project-lines="allProjectLines"
                  :all-project-desc="allProjectLines"
                  :all-projects="allProjects"
                  :project-favorites="allProjectLinesFavorites"
                  :custom-projects="orgSettings.customProjects"
                  :custom-project-lines="orgSettings.customProjectLines"
                  :use-custom-projects="!orgSettings.ERPenabled"
                ></ProjectSelect>
              </div>
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label is-normal">
            <label class="label">{{$t("settings.date")}}</label>
          </div>
          <div class="field-body">
            <div class="field is-narrow">
              <div class="control">
              <input v-model="date" class="input" type="date" :placeholder="$t('settings.date')">
              </div>
            </div>
          </div>
        </div>
        <div class="field-label is-normal">
          <label class="label">{{$t("settings.time")}}</label>
        </div>
        <div class="field-body">
          <div class="field is-narrow">
            <div class="control">
            <input v-model.number="time" class="input" type="number" :placeholder="$t('input.timeFx')" min=0 max=24 step="0.5">
            </div>
          </div>
        </div>
        <div class="field is-horizontal">
          <div class="field-label">
            <!-- Left empty for spacing -->
          </div>
          <div class="field-body">
            <div class="field">
              <div class="control">
                <button v-on:click="addRegistration" class="button is-primary">Gem</button>
              </div>
            </div>
          </div>
        </div>
        <!-- mobile project registration table -->
        <table class="table is-narrow">
          <tfoot>
            <tr>
              <th></th>
              <th>
                <a @click="sendRegistrationsForApproval(registrationsNotSentForApproval)" class="button is-primary">
                  <span>{{$t("input.sendForApp")}}</span>
                </a>
              </th>
              <th></th>
              <th>{{ totalTime }}</th>
              <th></th>
              <th></th>
            </tr>
          </tfoot>
          <tbody>
            <tr v-if="reg.sentForApproval == false" v-for="(reg, key) in registrationsNotSentForApproval" v-bind:key="key">
              <th>{{ key+1 }}</th>
                <td><strong>{{returnProjectDescription(reg.project, reg.isCustomProject)}} <span v-if="!reg.isCustomProject">({{ reg.project }})</span></strong><br><small>{{returnProjectLineDescription(reg.project, reg.projectLine, reg.isCustomProject)}} <span v-if="!reg.isCustomProject">({{reg.projectLine}})</span></small></td>
                <td>{{ formattedDate(reg.date) }}</td>
                <td>{{ reg.time }}</td>
                <td><a v-on:click="removeRegistration(reg)" class="delete"></a></td>
            </tr>
          </tbody>
        </table>
      </div>
      <table class="table is-hidden-mobile">
        <thead>
          <tr>
            <th><abbr title="Nummer">{{$t("settings.nr")}}</abbr></th>
            <th class="project-column">
              {{$t("settings.project")}}
              <a class="button is-info is-small" @click="useTimeTemplate()" v-if="isThereATimeTemplate" style="margin-left: 0.8em;">
                  <span class="icon">
                      <font-awesome-icon :icon="['fas', 'paste']"></font-awesome-icon>
                  </span>
                  {{$t("settings.useTimeTemplate")}}
              </a>
            </th>
            <th>{{$t("settings.date")}}</th>
            <th class="time-column">{{$t("settings.time")}}</th>
            <th>{{$t("settings.approval")}}</th>
            <th>{{$t("settings.save_delete")}}</th>
          </tr>
        </thead>
        <tfoot>
          <tr>
            <th></th>
            <th>
              <a @click="sendRegistrationsForApproval(registrationsNotSentForApproval)" class="button is-primary is-small">
                <span>{{$t("input.sendForApp")}}</span>
              </a>
            </th>
            <th></th>
            <th>{{ totalTime }}</th>
            <th></th>
            <td></td>
          </tr>
        </tfoot>
        <tbody>
          <tr v-if="reg.sentForApproval == false" v-for="(reg, key) in registrationsNotSentForApproval" v-bind:key="key">
            <th>{{ key+1 }}</th>
              <td>
                <strong>{{returnProjectDescription(reg.project, reg.isCustomProject)}}</strong>
                <span v-if="reg.project && !reg.isCustomProject" class="tag is-small is-info tag-margin">{{ reg.project }}</span>
                <br>
                <small>
                  {{ returnProjectLineDescription(reg.project, reg.projectLine, reg.isCustomProject) }}
                </small>
              </td>
              <td>{{ formattedDate(reg.date) }}</td>
              <td>{{ reg.time }}</td>
              <td>
                <span class="tag is-warning" v-if="reg.isRejected">Afvist</span>
              </td>
              <td><a v-on:click="removeRegistration(reg)" class="delete"></a></td>
            </tr>
            <tr>
              <th>{{$t("input.new")}}</th>
              <td>
                <ProjectSelect
                  @project="setProject" 
                  @projectTask="setProjectLine"
                  :all-project-lines="allProjectLines"
                  :all-project-desc="allProjectLines"
                  :all-projects="allProjects"
                  :project-favorites="allProjectLinesFavorites"
                  :custom-projects="orgSettings.customProjects"
                  :custom-project-lines="orgSettings.customProjectLines"
                  :use-custom-projects="!orgSettings.ERPenabled"
                  :use-standard-project="orgSettings.useStandardProject"
                  :standard-project="orgSettings.standardProject"
                ></ProjectSelect>
                <!-- <time-nav-project-line v-if="selectedProject" v-bind:project-from-component="selectedProject" @projectline="setProjectLine"> </time-nav-project-line> -->
              </td>
              <td>
                <p class="control">
                  <!-- <input v-model="date" class="input" type="date" placeholder="Dato"> -->
                  <Datepicker
                      v-model="date"
                      :language="da" 
                      class="input"
                      input-class="date-picker"
                      format="dd/MM/yy"
                      :monday-first="true"
                  ></Datepicker>
                </p>
              </td>
              <td>
                <p class="control">
                  <input v-model.number="time" class="input" type="number" :placeholder="$t('input.noHours')" min=0 max=24 step="0.5">
                </p>
              </td>
              <td></td>
              <td>
                <p class="control">
                    <a v-if="time === 0 || time > 24 " class="button is-danger is-outlined is-disabled is-small">{{$t("input.error")}}</a>
                    <a v-else @click="addRegistration()" class="button is-primary is-small" :disabled="!time">{{$t("input.save")}}</a>
                </p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
</template>

<script>
import firebase from '@/firebase'
import moment from 'moment'
import _ from 'lodash'
import ProjectSelect from '@/components/ProjectSelect'
import Datepicker from 'vuejs-datepicker'
import {en, da} from 'vuejs-datepicker/dist/locale'

import templates from '../utils/templates.vue'

export default {
  name: 'TimeTable',
  components: { 
      ProjectSelect,
      Datepicker
    },
  data: function () {
    return {
      da: da,
      en: en,
      project: '',
      date: (new Date()).toISOString().substring(0, 10),
      currentWeek: moment().isoWeek(),
      time: '',
      selectedProject: false,
      selectedProjectLine: false,
      projects: false,
      allProjects: false,
      allProjectLines: false,
      error: false,
    }
  },
  beforeCreate() {
    this.templates = templates
  },
  firebase: function() { 
    const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
    const userid = JSON.parse(localStorage.getItem('profile')).user_id;
    return {
        allRegistrations: {
            source: firebase.database().ref('/organisations/' + tenantid + '/registrations/' + userid),
        },
        allProjects: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobList'),
        },
        allProjectLines: {
            source: firebase.database().ref('/organisations/' + tenantid + '/JobTaskLines'),
        },
        allProjectLinesFavorites: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid + '/JobTaskLines'),
        },
        orgSettings: {
            source: firebase.database().ref('/organisations/' + tenantid + '/settings'),
            asObject: true,
        },
        personalSettings: {
            source: firebase.database().ref('/organisations/' + tenantid + '/userPreferences/' + userid),
            asObject: true,
        },
    }
  },
  computed: {
    isThereATimeTemplate() {
        if(this.personalSettings.timeTemplate) { return true } else { return false }
    },
    registrationsNotSentForApproval() {
      if(this.allRegistrations) {
        return _.filter(this.allRegistrations, { 'sentForApproval': false })
      }
    },
    totalTime: function() {
      Array.prototype.sum = function (prop) {
          var total = 0
          for ( var i = 0, _len = this.length; i < _len; i++ ) {
              total += this[i][prop]
          }
          return total
      }
      return this.registrationsNotSentForApproval.sum("time")
    },
  },
  methods: {
    useTimeTemplate() {
        const self = this;
        const regs = this.templates.methods.useTimeTemplate(this.$route.params.time, this.orgSettings, this.personalSettings, this.$i18n.locale)
        _.forEach(regs, function(registration) {
            self.$firebaseRefs.allRegistrations.push(registration)
        })
    },
    returnProjectDescription: function(projectNo, isCustom) {
      if(!isCustom) {
        const project = _.find(this.allProjects, { 'no': projectNo });
        if (project) {
          return project.description;
        } else {
          return;
        }
      } else {
        const project = _.get(this.orgSettings.customProjects, projectNo);
        if (project) {
          return project.name;
        } else {
          return;
        }
      }
    },
    returnProjectLineDescription: function(projectNo, lineNo, isCustom) {
      if(!isCustom) {
        const projectLine = _.find(this.allProjectLines, { 'no': projectNo , 'task_no': lineNo});
        if (projectLine) {
          return projectLine.description;
        } else {
          return;
        }
      } else {
        const projectLine = _.get(this.orgSettings.customProjectLines, lineNo);
        if (projectLine) {
          return projectLine.name;
        } else {
          return;
        }
      }
    },
    formattedDate: function(date) {
      return moment(date).format('DD/MM/YYYY');
    },
    setProject: function(projectNo) {
      this.selectedProject = projectNo;
    },
    setProjectLine: function(projectLine) {
      this.selectedProjectLine = projectLine;
    },
    addRegistration: function() {
        const tenantid = JSON.parse(localStorage.getItem('profile')).tenantid;
        const userid = JSON.parse(localStorage.getItem('profile')).user_id;
        let reg = {
          project: this.selectedProject,
          projectLine: this.selectedProjectLine,
          projectCombined: this.selectedProject + '-' + this.selectedProjectLine,
          uid: userid,
          tenantid: tenantid,
          date: moment(this.date).format('YYYY-MM-DD'),
          time: this.time,
          isApproved: false,
          quarter: moment(this.date).quarter(),
          sentForApproval: false,
          timestamp: moment().format()
        }
        if(this.orgSettings.ERPenabled == false) {
          reg.isCustomProject = true
        }
        this.$firebaseRefs.allRegistrations.push(reg)
        this.project = '';
        this.date = (new Date()).toISOString().substring(0, 10);
        this.time = '';
    },
    removeRegistration: function(registration) {
        // https://firebase.google.com/docs/reference/js/firebase.database.Reference#remove
        this.$firebaseRefs.allRegistrations.child(registration['.key']).remove()
    },
    sendRegistrationsForApproval: function(registrations) {
      // for each registration push an approval in firebase
      var updates = {};
      for (var i = 0, len = registrations.length; i < len; ++i) {
          // add update information to array
          updates[registrations[i]['.key'] + '/sentForApproval'] = true;
      }
      try {
         this.$firebaseRefs.allRegistrations.update(updates)
      } catch(error) {
          this.error = error
      } finally {
          if(!this.error) {
              if(_.find(registrations, {'sentForApproval': false})) {
                  this.$snotify.success('Sendt til godkendelse', {
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                    });
                } else {
                  this.$snotify.warning('Ingen registreringer der kan sendes til godkendelse', {
                    showProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true
                    });                    
                }
          }
      }
    }
  }
}
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .vdp-datepicker {
    width: 150px;
  } 
  .date-picker {
      border: none;
      width: 135px;
      height: 100%;
      font-size: 16px;
      font-family: "Avenir", Helvetica, Arial, sans-serif;
  }
  .tag-margin {
      margin-left: 0.5em;
  }
  .project-column {
    width: 35%;
  }
  .time-column {
    width: 10%
  }
</style>
